import $ from 'jquery';

export function initBanner ( ) {


  $(".banner:not(.simple)").each(function(index,obj){
    var $this= $(this);

    if ( $this.find("a").length ) {
      $this.css('cursor', 'pointer');
      $this.on("click",function(e){
        e.preventDefault();
        e.stopPropagation();
        document.location.href = $this.find("a").attr("href") ?? '';
      });

    }

  });

}
